import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import { selectors as jobListSelectors } from '../lib/redux/reducers/job/list';

const Wrapper = styled.div`
  height: 32px;
  background: ${colors.g02};
  color: ${colors.g04};
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  align-self: center;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
`;

export const JobBannerComponent = ({ activeJobTitle }) => <Wrapper>{activeJobTitle}</Wrapper>;

JobBannerComponent.propTypes = {
  activeJobTitle: PropTypes.string.isRequired
};

export const JobBanner = connect(state => ({
  activeJobTitle: jobListSelectors.activeJobTitle(state)
}))(JobBannerComponent);
